/*
 * File: sync-class.ts
 * File Created: 2024-01-20 09:13:20
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-03-04 03:45:17
 * Modified By: Val Liu
 * -----
 */

import { Vue } from "vue-property-decorator";

const LISTENER = Symbol(`Input Listener`);

/// experimental directive
/// v-sync-class="{ selector: 'input', classes: ['is-valid', 'is-invalid'] }"
/// to sync "input" classes in the list, back to this html element.
Vue.directive("sync-class", {
    inserted(el, binding) {
        const { selector, classes } = binding.value;
        const targetElement = el.querySelector(selector);

        const doSync = () => {
            /// sync class
            classes.forEach((className) => {
                if (targetElement.classList.contains(className)) {
                    if (!el.classList.contains(className)) el.classList.add(className);
                } else {
                    el.classList.remove(className);
                }
            });
        };

        if (targetElement) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === "class") {
                        doSync();
                    }
                });
            });

            doSync();
            observer.observe(targetElement, { attributes: true });
            el[LISTENER] = observer;
        }
    },

    unbind(el) {
        if (el[LISTENER]) {
            el[LISTENER].disconnect();
            delete el[LISTENER];
        }
    },
});
